import ECommerceAppConfig from './e-commerce/ECommerceAppConfig'
import AnalyticsDashboardAppConfig from './dashboards/analytics/AnalyticsDashboardAppConfig'

const appsConfigs = [AnalyticsDashboardAppConfig, ECommerceAppConfig]

export default appsConfigs
